<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div>
      <Header/>
    </div>
    <div>
        <DashboardNuevo></DashboardNuevo>
    </div>
    <div align="center" class="text-center w-30 justify-content-between" v-if="$localStorageService.can('Dash_Check_vers_Debug')">
      <div id="popover-debug">
        <span style="font-size: x-small; color: grey">Version</span>
      </div>
      <b-popover placement="down" target="popover-debug" triggers="hover blur">
        <b-form-checkbox v-model="debug" @input="localStorageValidar()" name="check-button" switch>
          Debug
        </b-form-checkbox>
      </b-popover>
    </div>
  </div>
</template>
<script>
//components
import Header from "../components/Header.vue";
import DashboardNuevo from "./DashboardNuevo.vue";

export default {
  components: {
    Header,
    DashboardNuevo
  },
  computed: { },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    sessions: [
      {
        name: null,
      },
    ],
    active: false,
    showDialog: false,
    datosDashboardRespuesta: null,
    postales: [],
    loadingSliders: false,
    datosClinica: null,
    loadingDatosClinica: false,
    blnClinicaDescentralizada: false,
    initComplete: false,
  }),
  async created() {
    this.debug = this.$localStorageService.getDebug();
    this.localStoraLaboratorios();
  },
  methods: {
    localStoraLaboratorios(){
      const filtros = {
        clinica: [],
        doctor: [],
        laboratorio: [],
        progreso: [],
        fechaInicio: null,
        fechaFin: null,
        idEtapaProceso: null,
        nombrePaciente: ''
      }

      localStorage.setItem("filtros", JSON.stringify( filtros ));

      const filtrosPerfil = {
        clinica: [],
        doctor: [],
        laboratorio: [],
        progreso: [],
        fechaInicio: null,
        fechaFin: null,
        idEtapaProceso: null,
        nombreTratamiento: ''
      }
      localStorage.setItem("filtrosPerfil", JSON.stringify( filtrosPerfil ))
    },
    localStorageValidar() {
      sessionStorage.setItem("debug", this.debug);
      this.version = process.env.VUE_APP_ENV_VERSION;
      location.reload();
    },
  }
};
</script>

<style scoped>
#carousel-fade {
  width: 700px !important;
  max-width: 700px !important;
  min-width: 700px !important;
  height: 350 !important;
  max-height: 350 !important;
  min-height: 350 !important;
}

.blue-footer {
  border-color: #0e6ba9 !important;
  color: #0e6ba9 !important;
  font-weight: bolder;
}

.blue {
  background-color: #0e6ba9;
}

.green {
  background-color: #1ea314;
}

.green-footer {
  border-color: #1ea314 !important;
  color: #1ea314 !important;
  font-weight: bolder;
}

.purple {
  background-color: #ac46a5;
}

.purple-footer {
  border-color: #ac46a5 !important;
  color: #ac46a5 !important;
  font-weight: bolder;
}

.orange {
  background-color: #ed8c1d;
}

.orange-footer {
  border-color: #ed8c1d !important;
  color: #ed8c1d !important;
  font-weight: bolder;
}

.header-card {
  padding-top: 5px;
  padding-bottom: 5px;
  color: white;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  font-weight: bolder;
  font-size: 14px;
}

.footer-card {
  padding-top: 10px;
  padding-bottom: 10px;
  border: 1px solid;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  font-size: 15px !important;
}

.footer-text {
  font-size: 20px !important;
}

.tamanoSkeleton {
  width: 100%;
}

.img-fluid {
  height: 350 !important;
  min-height: 350 !important;
  max-height: 350 !important;
}

.heightModal {
  height: 640px !important;
}

.black {
  color: black !important;
}

.disabledSesion {
  color: gray !important;
  cursor: default !important;
}

.container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  height: auto;
  width: auto;
}

.left {
  display: flex;
  flex-wrap: wrap;
  text-align: left;
  /* background-color: red !important;*/
  width: 50%;
  height: auto;
  color: black !important;
  font-size: 100% !important;
  padding-top: 1% !important;
}

.center {
  display: flex;
  flex-wrap: wrap;
  background-color: yellow;
  height: auto;
  width: auto;
}

.right {
  display: flex;
  flex-wrap: wrap;
  text-align: left;
  /* background-color: red !important;*/
  width: auto;
  height: auto;
  color: black !important;
  font-size: 100% !important;
  padding-top: 1% !important;
}

.navbar {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  height: auto;
  width: auto;
}

.body {
  display: flex-start;
  flex-wrap: wrap;
  flex-direction: column;
  flex: 1;
  align-items: center;
  margin: 1% !important;
  width: auto;
  height: auto;
}

.header-dashboard {
  /* height: 350px !important;
  min-height: 350px !important;
  max-height: 350px !important; */
  display: flex;
  width: auto;
  height: auto;
  margin: 10px !important;
  margin-top: 10px !important;
  flex-direction: row;
  justify-content: flex-start;
}

.sectionb {
  background-color: whitesmoke !important;
  width: 100%;
  height: auto;
  margin: 10px;
  margin-top: 10px;
  padding: 10px;
}

.carrusel {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  /*background-color: white !important; */
  background-color: #f6f6f6 !important;
  margin: 1% !important;
  width: 65%;
  height: 90%;
  text-align: -webkit-center !important;
}

.responsivo {
  display: block;
  max-width: 100%;
  max-height: 100%;
  flex-direction: row;
  flex-wrap: wrap;
  width: 98%;
  height: 30%;
  background-color: #f6f6f6 !important;
  margin: 1% !important;
  justify-content: center;
}

.cards {
  display: flex;
  flex-direction: row;
  margin: 1% !important;
  width: 35%;
  justify-content: space-around;
  flex-wrap: wrap;
}

.cards-container {
  display: flex;
  flex-wrap: initial;
  flex-direction: column;
  margin: 1% !important;
  width: 48%;
  justify-content: space-between;
}

/*cards*/

.minicard {
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  /* margin: 10% !important; */
  margin-bottom: 20px;
  width: 85%;
  flex-wrap: wrap;
  /*border: 1px solid black;*/
}

.headerCard {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: auto;
  height: auto;
  /*background-color: white;*/
  background-color: rgb(241, 238, 238);
  font-size: 100% !important;
}

.headerCardIngresos {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: auto;
  height: auto;
  /*background-color: white;*/
  background: linear-gradient(#98b10c, #c3d463);
  background-color: #73a432;
}

.headerCardFechaHora {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: auto;
  height: auto;
  /*background-color: white;*/
  background: linear-gradient(#dda218, #e6bf66);
  font-size: 100% !important;
  /* background-color:#f2793f;*/
}

.headerCardDoctor {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: auto;
  height: auto;
  /*background-color: white;*/
  font-size: 100% !important;
  /*background-color:#379bce;*/
  background: linear-gradient(#66b8e0, #90cbe9);
}

.headerCardConta {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: auto;
  height: auto;
  /*background-color: white;*/
  /*  background-color: rgb(241, 238, 238);*/
  font-size: 100% !important;
  background: radial-gradient(#c59bcc, #d89fe4);
}

.imgCard {
  display: flex;
  flex-wrap: wrap;
  width: 30%;
  height: 50%;
}

.txtHeader {
  display: flex;
  width: 50%;
  height: 5%;
  margin-top: 1%;
  flex-wrap: wrap;
  justify-content: center;
  /* font-size: auto !important;*/
  font-weight: 500;
  font-size: 120%;
  color: white;
}

.divFlotante {
  /*  background-color: pink;*/
  display: flex;
  margin-top: -30%;
  margin-left: -15%;
  flex-wrap: wrap;
}

.footerCard {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: auto;
  height: auto;
  background-color: white;
  font-size: auto !important;
}

.footerCardIngresos {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: auto;
  height: auto;
  margin-top: -5%;
  /*  background: linear-gradient(180deg,#bbd32d,#eefba4);*/
  background: radial-gradient(#c3d463, #98b10c);
  /*background-color: #bbd32d;*/
  padding-top: 5%;
  font-size: 190%;
  font-weight: 900;
  color: white;
}

.footerCardFechaHora {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: auto;
  height: auto;
  margin-top: -5%;

  /*  background-color: #fdc84d;*/
  background: radial-gradient(#e6bf66, #dda218);
  padding-top: 5%;
  font-size: 190%;
  font-weight: 900;
  color: white;
}

.footerCardDoctor {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: auto;
  height: auto;
  margin-top: -5%;
  /*  background-color: #8ad1f5;*/
  background: radial-gradient(#83bedb, #66b8e0);
  padding-top: 5%;
  font-size: 190%;
  font-weight: 900;
  color: white;
}

.footerCardConta {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: auto;
  height: auto;
  margin-top: -5%;

  /* background-color: #caa7d1;*/
  background: radial-gradient(#c59bcc, #c38dce);
  padding-top: 5%;
  font-size: 190%;
  font-weight: 900;
  color: white;
}

@media screen and (max-width: 500px) {
  .header-dashboard {
    display: flex;
    width: auto;
    height: auto;
    margin: 10px !important;
    margin-top: 10px !important;
    flex-direction: row;
    justify-content: flex-start;
  }
}

@media screen and (max-width: 576px) {
  #carousel-fade {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 100% !important;
    height: 150px !important;
    max-height: 150px !important;
    min-height: 150px !important;
  }

  .header-dashboard {
    display: flex;
    width: 100%;
    height: auto;
    margin: 10px !important;
    margin-top: 10px !important;
    flex-direction: column;
    justify-content: flex-start;
  }

  .carrusel {
    display: flex;
    /*display: block*/
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    /*   background-color: white !important; */
    background-color: #f6f6f6 !important;
    margin: 1% !important;
    justify-content: flex-start;
  }

  .cards {
    display: flex;
    flex-direction: row;
    margin: 50px !important;
    width: 100%;
    justify-content: space-around;
    flex-wrap: wrap;
  }

  .cards-container {
    display: flex;
    flex-wrap: initial;
    flex-direction: column;
    margin: 1% !important;
    width: 22%;
    height: 10%;
    justify-content: space-between;
  }

  .responsivo {
    display: flex;
    /*display: block*/
    flex-direction: row;
    flex-wrap: wrap;
    width: 80%;
    height: 45%;
    /*   background-color: white !important; */
    background-color: #f6f6f6 !important;
    margin: 1% !important;
    justify-content: flex-start;
  }

  .txtHeader {
    display: flex;
    width: 40%;
    height: 5%;
    margin: -10%;
    flex-wrap: wrap;
    justify-content: center;
    font-size: 100% !important;
  }

  .imgCard {
    display: flex;
    flex-wrap: wrap;
    width: 42%;
    height: 50%;
  }

  .divFlotante {
    /*  background-color: pink;*/
    display: flex;
    margin-top: -55%;
    margin-left: -50%;
    flex-wrap: wrap;
  }

  .footerCard {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: auto;
    height: auto;
    background-color: white;
    font-size: 150 !important;
  }
}

@media screen and (max-width: 1200px) {
  #carousel-fade {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 100% !important;
    /* height: 200px !important;
    max-height: 200px !important;
    min-height: 200px !important; */
  }

  .sectionb {
    margin-top: 60px;
  }
}
</style>
